import { COLOR_THEMES, IColorTheme } from './color-themes';

/** Determines the color and size of the plot and someother miscelaneous display properties */
export interface IUiOptions {
    disableMenuLabelText?: string;
    numBins?: number;
    grid?: {
        rows: number;
        cols: number;
    };
    darkTheme?: boolean;
    colorTheme?: IColorTheme;
    legendAlign?: 'left' | 'right';
    latisBase?: string;
    eventsURL?: string;
    features?: IUiFeatures;
}

export interface IUiFeatures {
    featureList: string[];
    toolbar: boolean;
    filters: boolean;
    metadata: boolean;
    download: boolean;
    globalSettings: boolean;
    overplot: boolean;
    limits: boolean;
    events: boolean;
    binnedData: boolean;
    discreteData: boolean;
    rangeSelector: boolean;
    collapsible: boolean;
    modifyDatasetsButton: boolean;
}

// just a handy human readable list of UI features we can turn on/off
// usefull if an app wants to let the user configure these features
export const featureList = [
    'Toolbar',
    'Filters',
    'Metadata',
    'Download',
    'Global Settings',
    'Overplot',
    'Limits',
    'Events',
    'Binned Data',
    'Discrete Data',
    'Range Selector',
    'Collapsible Plot',
    'Modify Datasets Button'
];

export const DEFAULT_UI_OPTIONS: IUiOptions = {
    disableMenuLabelText: 'Disable menu',
    numBins: undefined,
    darkTheme: false,
    grid: {
        rows: 1,
        cols: 1
    },
    colorTheme: COLOR_THEMES.light,
    legendAlign: 'left',
    latisBase: '',
    eventsURL: undefined,
    features: {
        featureList: featureList,
        toolbar: true,
        filters: true,
        metadata: true,
        download: true,
        globalSettings: true,
        overplot: true,
        limits: true,
        events: true,
        binnedData: true,
        discreteData: true,
        rangeSelector: true,
        collapsible: true,
        modifyDatasetsButton: true
    }
};
